/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { useDispatch } from "react-redux";
import { Button, ListGroupItem } from "reactstrap";
import { assignDeviceToTenant, deleteDevice, selectDevice } from "../../actions/Devices/actions";
import { RootConfigType } from "../../actions/Tenants/config/constantsTyped";
import { RootState } from "../../reducers";
import DeviceLastSeen from "./DeviceLastSeen";
import DeviceTenantDropdown from "./DeviceTenantDropdown";

export interface Device {
    UID: string;
    name: string;
    type: string;
    tenant_id: string;
    last_seen?: string;
    device_id?: string;
}

interface DeviceItemProps {
    device: Device;
    selectedDevice?: Device;
    user: RootState["auth"]["user"];
    config: RootConfigType;
    testId?: string;
}

export function DeviceItem({
    device,
    selectedDevice,
    user,
    config,
    testId
}: DeviceItemProps) {
    const dispatch = useDispatch();

    const isSelected = selectedDevice?.UID === device.UID;
    const canSelect = device.tenant_id === user.tenant.tenant_id || user.email.endsWith("@experiencedata.nl");

    return (
        <ListGroupItem key={`${device.type}-${device.UID}`} data-testid={testId}>
            <div className="d-lg-flex justify-content-between align-items-center py-2">
                <div>
                    <strong>{device.name}</strong>
                    <div className="text-muted text-small">
                        <DeviceLastSeen device={device} />
                    </div>
                </div>
                <div className="d-flex align-items-end pt-1">
                    {config.is_admin && (
                        <div className="me-3 mb-1 mb-sm-0" css={css`width: 150px;`}>
                            <DeviceTenantDropdown
                                device={device}
                                onChange={(tenant_id: string) => dispatch(assignDeviceToTenant({
                                    ...device,
                                    tenant_id,
                                    tenant: tenant_id
                                }) as any)}
                            />
                        </div>
                    )}
                    {config.is_admin && (
                        <Button
                            className="me-3 mb-1 mb-sm-0"
                            disabled={isSelected}
                            color="danger"
                            outline
                            onClick={() => dispatch(deleteDevice(device.UID) as any)}
                        >
                            Delete
                        </Button>
                    )}
                    {canSelect && (
                        <Button
                            color="success"
                            outline={!isSelected}
                            onClick={() => dispatch(selectDevice(device) as any)}
                        >
                            Select
                        </Button>
                    )}
                </div>
            </div>
        </ListGroupItem>
    );
}
